import axios from 'axios';

export const getRequest = async (url, params) => {
  const { data } = await axios.get(
    `${process.env.REACT_APP_API_BASEURL}/${url}`, { params }
  )
  return data
}

export const putRequest = async (url, data) => {
  return axios.put(`${process.env.REACT_APP_API_BASEURL}/${url}/`, data)
}

export const getCarerMint = async (address) => {
  return getRequest(`memoryforms`, { address })
}

export const getLifeform = async (tokenId) => {
  return getRequest(`gooddeath/${tokenId}`)
}

export const createMemoryform = async (data) => {
  return putRequest(`memoryforms`, data)
}

export const createDeathform = async (data) => {
  return putRequest(`gooddeath`, data)
}
